import React from 'react'
import clsx from 'classnames'
import styles from './ServicesSubCategory.module.scss'

type ServicesSubCategoryProps = {
  name: string,
  expanded: React.ReactNode[],
  collapsed: React.ReactNode[],
  isExpanded: boolean,
  onExpand: () => void,
  onCollapse: () => void,
}

export const ServicesSubCategory: React.FC<ServicesSubCategoryProps> = (props) => {
  const { name, expanded, collapsed, isExpanded, onExpand, onCollapse } = props
  const visible = isExpanded ? expanded : collapsed
  return (
    <div className={clsx([styles.container, { [styles.expanded]: isExpanded }])}>
      <div className={styles.header} onClick={isExpanded ? onCollapse : onExpand}>
        <span className={styles.name}>{name}</span>
        <i className={styles.arrow} />
      </div>
      {React.Children.count(visible) > 0 && <div className={styles.children}>
        {visible}
      </div>}
    </div>
  )
}
